import React, { forwardRef } from 'react';

import { CommonTheme, useCurrentTheme } from 'app/shared/theme';
import { WithBorderProps } from 'app/shared/components/styleUtils';
import { Box, BoxProps } from 'app/shared/components/atoms';

export const BasePageBox = forwardRef<HTMLDivElement, BoxProps>(
  (
    {
      children,
      backgroundColor,
      backgroundImage,
      minHeight,
      display,
      animation,
      w = '100vw',
      b,
      br,
      bt,
      bb,
      bl,
      bw,
      borderRadius,
      borderRadiusBottomLeft,
      borderRadiusBottomRight,
      borderRadiusTopLeft,
      borderRadiusTopRight,
      ...props
    },
    ref
  ) => {
    const { dimensions } = useCurrentTheme() as CommonTheme;
    const withBorderProps: WithBorderProps = {
      b,
      br,
      bt,
      bb,
      bl,
      bw,
      borderRadius,
      borderRadiusBottomLeft,
      borderRadiusBottomRight,
      borderRadiusTopLeft,
      borderRadiusTopRight,
    };

    return (
      <Box
        w={w}
        backgroundColor={backgroundColor}
        backgroundImage={backgroundImage}
        display={display}
        minHeight={minHeight}
        animation={animation}
        ref={ref}
        {...withBorderProps}
      >
        <Box
          mx="auto"
          maxWidth={`${dimensions.maxPageWidth}px`}
          px={dimensions.horizontalPadding.page}
          minHeight={minHeight}
          display={display}
          w="100%"
          {...props}
        >
          {children}
        </Box>
      </Box>
    );
  }
);
